import { useMemo } from 'react';

import { ChatWidget } from '@/modules/chat/components/ChatWidget';

import { AssistantContext } from '../context/assistant';

export const AssistantProvider = ({
  children,
  isAuthorized,
  showWidget = true,
}: {
  children: React.ReactNode;
  isAuthorized: boolean;
  showWidget?: boolean;
}) => {
  const contextValue = useMemo(() => ({ isAssistantEnabled: isAuthorized }), [isAuthorized]);

  return (
    <AssistantContext.Provider value={contextValue}>
      {children}
      {isAuthorized && showWidget && <ChatWidget />}
    </AssistantContext.Provider>
  );
};
